export function avatarTitle(user) {
  return user?.full_name || user?.name || user?.email || ''
}

export function Avatar({ user, size = 'xs', online = false, className = '' }) {
  const title = avatarTitle(user)
  const classes = [ 'avatar', `avatar-${size}` ]
  if (online) classes.push('avatar-online')
  if (className) classes.push(className)

  return (
    <span className={classes.join(' ')} data-bs-toggle="tooltip" data-bs-title={title} aria-label={title}>
      <img src={user?.avatar_url} className="avatar-img rounded-circle" alt={title} />
    </span>
  )
}
